<fz-header></fz-header>

<div class="main">
  <router-outlet></router-outlet>
</div>

<fz-footer></fz-footer>
